// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import * as DmsCommon from '../supports/dms-common';
import FolderTreeList2 from './FolderTreeList2';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Checkbox from '@mui/material/Checkbox';
import PrintIcon from '@mui/icons-material/Print';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


function SelFolderDialog(props) {

  const { open, onClose, onSelectFolderID } = props;

  const iniFolderID = (props.iniFolderID == undefined ? DmsCommon.VOID_FOLDER_ID : props.iniFolderID);
  const folders = props.folders || [];
  const limitedRootFolderIDs = props.limitedRootFolderIDs || null;
  const disableAllFolder = (props.disableAllFolder === true) || false;
  const disablePersonalFolder = (props.disablePersonalFolder === true) || false;
  const disablePhyLocFolder = (props.disablePhyLocFolder === true) || false;



  // console.log('SelFolderDialog disableAllFolder', disableAllFolder);
  // console.log('SelFolderDialog iniFolderID', iniFolderID);

  const [selFolderID, setSelFolderID] = useState(DmsCommon.VOID_FOLDER_ID);

  useEffect(() => {
    // if (open) {
    //   setSelFolderID(iniFolderID);
    // }
  }, [open])

  const handleCloseClick = () => {
    onClose && onClose();
  }

  const handleChangeFolderID = (aFolderID) => {
    setSelFolderID(aFolderID);
  }

  const handleSelectClick = () => {
    onSelectFolderID && onSelectFolderID(selFolderID);
  }

  return (

    <Dialog
      fullWidth={true}
      maxWidth={"sm"}
      open={open}
      aria-describedby="dialog-sel-folder"

      scroll="paper"
      PaperProps={{
        sx: {
          display: 'flex',
          minHeight: "80vh",
          maxHeight: "80vh",
        }
      }}
    >
      <DialogTitle>Select Folder</DialogTitle>
      <DialogContent>
        <Box
          component="div"
          sx={{
            // p: 0, height: 1, maxHeight: 1,
            // overflow: 'auto',
            display: 'flex', p: 0, height: "60vh", overflow: 'auto'
          }}>
          <FolderTreeList2
            folders={folders}
            selFolderID={selFolderID}
            onChangeFolderID={handleChangeFolderID}
            limitedRootFolderIDs={limitedRootFolderIDs}
            disableAllFolder={disableAllFolder}
            disablePersonalFolder={disablePersonalFolder}
            disablePhyLocFolder={disablePhyLocFolder}
            disableReadCnt
          />

        </Box>



      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseClick}>Cancel</Button>
        <Button type="submit" disabled={selFolderID == DmsCommon.VOID_FOLDER_ID} variant="contained" onClick={handleSelectClick}>Select</Button>
      </DialogActions>
    </Dialog>

  );
}

SelFolderDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  folders: PropTypes.array,
  limitedRootFolderIDs: PropTypes.array,
  iniFolderID: PropTypes.number,
  disableAllFolder: PropTypes.bool,
  disablePersonalFolder: PropTypes.bool,
  disablePhyLocFolder: PropTypes.bool,
  onSelectFolderID: PropTypes.func,

};

export default SelFolderDialog